import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { GroupsComponentsModule } from 'app/groups/groups-components.module';
import { AgentsRoutingModule } from './agents-routing.module';
import { UiService } from '../core';
import { AgentDetailComponent } from './agent-detail/agent-detail.component';
import { AgentsComponent } from './agents.component';
import { AgentCreateComponent } from './agent-create/agent-create.component';

@NgModule({
  imports: [CommonModule, CoreModule, GroupsComponentsModule, AgentsRoutingModule],
  declarations: [AgentDetailComponent, AgentsComponent, AgentCreateComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AgentsModule {
  constructor(public uiService: UiService) {}
}
